import React,{ useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { LoadingPage } from "./loading";
import Store from "../redux/store";
import {
  RefushTokenCallBack
} from "../auth/authInstance";
import {
  UserLoginAction,
} from "../redux/actions";
import { notification } from "antd";

import i18n from "@src/locales";

function NavPage() {
  return <Redirect to="/home/index" />;
}

function RefreshPage() {
  const [isLogin,setIsLogin]  =useState<boolean>(false);
  useEffect(()=>{
    RefushTokenCallBack().then(re=>{
      if(re){
        setIsLogin(true)
        Store.dispatch(UserLoginAction(re));
      }else{
        setIsLogin(false)
        
      }
    }).catch(c=>{
      setIsLogin(false)
      notification.error({message: i18n.language === "zh" ? "刷新token失败" : "Refresh token failed"})
    })
  }, [])
  return (
    <div >
      {!isLogin? (
        <LoadingPage></LoadingPage>
      ) : (
        <NavPage></NavPage>
      )}
    </div>
  );
}

export default RefreshPage;
